
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'Card',
  props: {
    icon: { type: String },
    title: { type: String },
  },
});
